import React, { useState } from "react";
import {
    Box,
    Collapse,
    Divider,
    IconButton,
    Paper,
    Typography
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function FormSection({
    title,
    icon: Icon,
    children,
    defaultOpen = true,
    sx,
    renderProp,
    hide
}) {
    const [open, setOpen] = useState(defaultOpen);

    const handleToggle = () => {
        setOpen((prev) => !prev);
    };

    if (hide) return null;

    return (
        <Paper
            variant="outlined"
            sx={{
                p: { xs: 2, md: 2.5 }, // Tightened padding
                borderRadius: 2,
                borderColor: "#E2E8F0",
                backgroundColor: "#FFFFFF",
                boxShadow: "0 2px 10px rgba(0, 0, 0, 0.02)",
                ...sx
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    mb: 2
                }}
            >
                <Divider
                    textAlign="left"
                    sx={{
                        flexGrow: 1,
                        "& .MuiDivider-wrapper": {
                            paddingLeft: 0,
                            paddingRight: 0
                        },
                        "&::before": { width: 0 },
                        "&::after": { borderColor: "#E2E8F0" }
                    }}
                >
                    <Box
                        onClick={handleToggle}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.25,
                            cursor: "pointer",
                            userSelect: "none",
                            "&:hover .toggle-icon": { color: "#C25953" }
                        }}
                    >
                        {Icon && (
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: 32,
                                    height: 32,
                                    borderRadius: 1.5,
                                    backgroundColor: "rgba(194, 89, 83, 0.08)",
                                    color: "#C25953"
                                }}
                            >
                                <Icon sx={{ fontSize: 18 }} />
                            </Box>
                        )}

                        <Typography
                            variant="h6"
                            sx={{
                                fontSize: "1rem",
                                fontWeight: 700,
                                color: "#2D3748",
                                letterSpacing: "-0.2px"
                            }}
                        >
                            {title}
                        </Typography>

                        <IconButton
                            size="small"
                            className="toggle-icon"
                            sx={{
                                ml: 0.5,
                                p: 0.25,
                                color: "#718096",
                                transform: open
                                    ? "rotate(180deg)"
                                    : "rotate(0deg)",
                                transition:
                                    "transform 0.2s ease, color 0.2s ease"
                            }}
                        >
                            <ExpandMoreIcon fontSize="small" />
                        </IconButton>
                    </Box>
                </Divider>

                {/* 👇 Button rendered after divider line */}
                <Box sx={{ ml: 2 }}>{renderProp}</Box>
            </Box>

            <Collapse in={open} timeout="auto" unmountOnExit>
                <Box sx={{ pt: 0.5 }}>{children}</Box>
            </Collapse>
        </Paper>
    );
}
